<template>
  <div
    @mouseover="showBottomBar"
    @mouseout="hideBottomBar"
    :class="hideBar ? 'hide-bar' : ''"
    class="bottombar d-flex justify-content-between align-items-center opacity"
  >
    <div class="profile d-flex justify-content-start align-items-center">
      <div class="userimg mr-2">
        <img v-if="img" :src="img" alt="User Image" />
        <a-avatar v-else shape="circle" icon="user" :size="35" />
      </div>
      <div>
        <h3 class="title">{{ plan || "Open Session" }}</h3>
        <h4 class="with">
          <span v-if="!$route.query.code"> With {{ name }} </span>
          <span v-if="$route.query.code"> With User </span>
          <svg
            v-show="otherUserMicMuted"
            width="16"
            height="17"
            viewBox="0 0 16 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0)">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M6.41841 1.01663C6.95085 0.624413 7.61004 0.444025 8.268 0.510486C8.92596 0.576946 9.53575 0.885514 9.979 1.37629C10.4221 1.86689 10.6672 2.50459 10.6667 3.16566M10.6667 3.16633L10.6667 6.72566C10.6667 7.09385 10.3682 7.39233 10 7.39233C9.63181 7.39233 9.33333 7.09385 9.33333 6.72566V3.16499C9.33367 2.83434 9.21113 2.51536 8.9895 2.26997C8.76788 2.02458 8.46298 1.8703 8.134 1.83707C7.80502 1.80384 7.47543 1.89403 7.20921 2.09014C6.94299 2.28625 6.75913 2.57428 6.69333 2.89832C6.62007 3.25915 6.26816 3.49226 5.90734 3.41899C5.54651 3.34573 5.3134 2.99382 5.38667 2.633C5.51826 1.98492 5.88597 1.40885 6.41841 1.01663M0.195262 0.694257C0.455612 0.433907 0.877722 0.433907 1.13807 0.694257L11.6634 11.2196C11.7121 11.2473 11.758 11.2817 11.7999 11.3228C11.8452 11.3672 11.8828 11.4165 11.9128 11.469L15.8047 15.3609C16.0651 15.6213 16.0651 16.0434 15.8047 16.3037C15.5444 16.5641 15.1223 16.5641 14.8619 16.3037L11.2886 12.7304C10.5242 13.3258 9.61254 13.6955 8.66667 13.8164V15.1657H10.6667C11.0349 15.1657 11.3333 15.4641 11.3333 15.8323C11.3333 16.2005 11.0349 16.499 10.6667 16.499H5.33333C4.96514 16.499 4.66667 16.2005 4.66667 15.8323C4.66667 15.4641 4.96514 15.1657 5.33333 15.1657H7.33333V13.8209C6.86883 13.7643 6.40873 13.6461 5.96611 13.4635C3.97577 12.6425 2.65196 10.6495 2.66667 8.49663V7.16566C2.66667 6.79747 2.96514 6.49899 3.33333 6.49899C3.70152 6.49899 4 6.79747 4 7.16566V8.50387C3.98822 10.1142 4.98591 11.6168 6.47455 12.2309C6.90713 12.4093 7.36321 12.5053 7.82026 12.5235C7.87744 12.5075 7.93772 12.499 8 12.499C8.0604 12.499 8.11893 12.507 8.17457 12.5221C8.94515 12.4853 9.70186 12.2298 10.336 11.7778L9.35323 10.795C9.09652 10.9462 8.81492 11.0541 8.5196 11.1128C8.00262 11.2155 7.46681 11.1627 6.97983 10.961C6.49285 10.7594 6.07654 10.418 5.78349 9.97987C5.49045 9.54177 5.3338 9.02665 5.33333 8.49958L5.33333 6.77514L0.195262 1.63707C-0.0650874 1.37672 -0.0650874 0.954606 0.195262 0.694257ZM6.66667 8.10847V8.49841C6.6669 8.76194 6.74522 9.0195 6.89175 9.23855C7.03827 9.4576 7.24642 9.62832 7.48991 9.72914C7.7334 9.82996 8.00131 9.85636 8.2598 9.80501C8.28803 9.7994 8.31601 9.79289 8.3437 9.78551L6.66667 8.10847ZM12.6667 6.49899C13.0349 6.49899 13.3333 6.79747 13.3333 7.16566C13.3333 7.30377 13.3359 7.45075 13.3386 7.60416C13.3486 8.16884 13.3601 8.82053 13.2495 9.43672C13.1845 9.79912 12.838 10.0402 12.4756 9.97518C12.1132 9.91017 11.8721 9.56367 11.9371 9.20127C12.0224 8.72602 12.0146 8.25167 12.0058 7.71101C12.003 7.53685 12 7.35582 12 7.16566C12 6.79747 12.2985 6.49899 12.6667 6.49899Z"
                fill="#EF5C4A"
              />
            </g>
            <defs>
              <clipPath id="clip0">
                <rect
                  width="16"
                  height="16"
                  fill="white"
                  transform="translate(0 0.5)"
                />
              </clipPath>
            </defs>
          </svg>
          <!-- <svg
            width="22"
            height="22"
            viewBox="0 0 22 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M15.0332 4.85832C15.0332 4.20018 15.5667 3.66666 16.2249 3.66666C16.883 3.66666 17.4165 4.20018 17.4165 4.85832V16.775C17.4165 17.4331 16.883 17.9667 16.2249 17.9667C15.5667 17.9667 15.0332 17.4331 15.0332 16.775V4.85832Z"
              fill="#DDDDDD"
            />
            <path
              d="M5.5 13.2C5.5 12.5418 6.03353 12.0083 6.69167 12.0083C7.34981 12.0083 7.88333 12.5418 7.88333 13.2V16.775C7.88333 17.4331 7.34981 17.9666 6.69167 17.9666C6.03353 17.9666 5.5 17.4331 5.5 16.775V13.2Z"
              fill="var(--theme-color)"
            />
            <path
              d="M10.2666 8.43333C10.2666 7.77519 10.8001 7.24167 11.4583 7.24167C12.1164 7.24167 12.6499 7.7752 12.6499 8.43333V16.775C12.6499 17.4331 12.1164 17.9667 11.4583 17.9667C10.8001 17.9667 10.2666 17.4331 10.2666 16.775V8.43333Z"
              fill="var(--theme-color)"
            />
          </svg> -->
          <svg
            v-show="otherUserMicMuted"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M16.3999 5.3C16.3999 4.58203 16.9819 4 17.6999 4C18.4179 4 18.9999 4.58203 18.9999 5.3V18.3C18.9999 19.018 18.4179 19.6 17.6999 19.6C16.9819 19.6 16.3999 19.018 16.3999 18.3V5.3Z"
              fill="none"
            />
            <path
              d="M6 14.4C6 13.682 6.58203 13.1 7.3 13.1C8.01797 13.1 8.6 13.682 8.6 14.4V18.3C8.6 19.018 8.01797 19.6 7.3 19.6C6.58203 19.6 6 19.018 6 18.3V14.4Z"
              fill="none"
            />
            <path
              d="M11.2002 9.20001C11.2002 8.48204 11.7822 7.90001 12.5002 7.90001C13.2182 7.90001 13.8002 8.48204 13.8002 9.20001V18.3C13.8002 19.018 13.2182 19.6 12.5002 19.6C11.7822 19.6 11.2002 19.018 11.2002 18.3V9.20001Z"
              fill="none"
            />
          </svg>
          <svg
            v-show="!otherUserMicMuted && connectionState == 'connected'"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              id="remoteAudio3"
              d="M16.3999 5.3C16.3999 4.58203 16.9819 4 17.6999 4C18.4179 4 18.9999 4.58203 18.9999 5.3V18.3C18.9999 19.018 18.4179 19.6 17.6999 19.6C16.9819 19.6 16.3999 19.018 16.3999 18.3V5.3Z"
              fill="none"
            />
            <path
              id="remoteAudio1"
              d="M6 14.4C6 13.682 6.58203 13.1 7.3 13.1C8.01797 13.1 8.6 13.682 8.6 14.4V18.3C8.6 19.018 8.01797 19.6 7.3 19.6C6.58203 19.6 6 19.018 6 18.3V14.4Z"
              fill="none"
            />
            <path
              id="remoteAudio2"
              d="M11.2002 9.20001C11.2002 8.48204 11.7822 7.90001 12.5002 7.90001C13.2182 7.90001 13.8002 8.48204 13.8002 9.20001V18.3C13.8002 19.018 13.2182 19.6 12.5002 19.6C11.7822 19.6 11.2002 19.018 11.2002 18.3V9.20001Z"
              fill="none"
            />
          </svg>
          <!-- <button class="ml-2 btn-fill">Charity</button> -->
        </h4>
      </div>
    </div>
    <div class="actions d-flex justify-content-center align-items-center">
      <button
        class="video"
        :class="{ active: muteCamera }"
        @click="handleToggleVideo"
      >
        <svg
          width="22"
          height="22"
          viewBox="0 0 22 22"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0)">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M3.125 5.75C2.89294 5.75 2.67038 5.84219 2.50628 6.00628C2.34219 6.17038 2.25 6.39294 2.25 6.625V15.375C2.25 15.6071 2.34219 15.8296 2.50628 15.9937C2.67038 16.1578 2.89294 16.25 3.125 16.25H12.75C12.9821 16.25 13.2046 16.1578 13.3687 15.9937C13.5328 15.8296 13.625 15.6071 13.625 15.375V14.8624L4.51256 5.75H3.125ZM1.26884 4.76884C1.76113 4.27656 2.42881 4 3.125 4H4.875C5.10706 4 5.32962 4.09219 5.49372 4.25628L15.1187 13.8813C15.2828 14.0454 15.375 14.2679 15.375 14.5V15.375C15.375 16.0712 15.0984 16.7389 14.6062 17.2312C14.1139 17.7234 13.4462 18 12.75 18H3.125C2.42881 18 1.76113 17.7234 1.26884 17.2312C0.776562 16.7389 0.5 16.0712 0.5 15.375V6.625C0.5 5.92881 0.776562 5.26113 1.26884 4.76884ZM12.75 5.75H9.8275C9.34425 5.75 8.9525 5.35825 8.9525 4.875C8.9525 4.39175 9.34425 4 9.8275 4H12.75C13.4462 4 14.1139 4.27656 14.6062 4.76884C15.0984 5.26113 15.375 5.92881 15.375 6.625V9.18506L15.4664 9.27647L20.1122 5.91603C20.3785 5.72338 20.7303 5.69625 21.0231 5.84579C21.3158 5.99532 21.5 6.2963 21.5 6.625V15.375C21.5 15.8582 21.1082 16.25 20.625 16.25C20.1418 16.25 19.75 15.8582 19.75 15.375V8.33783L15.8878 11.1315C15.5396 11.3833 15.0601 11.3451 14.7563 11.0412L13.8813 10.1662C13.7172 10.0021 13.625 9.77956 13.625 9.5475V6.625C13.625 6.39294 13.5328 6.17038 13.3687 6.00628C13.2046 5.84219 12.9821 5.75 12.75 5.75Z"
              fill="#EF5C4A"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M0.756282 0.756282C1.09799 0.414573 1.65201 0.414573 1.99372 0.756282L21.2437 20.0063C21.5854 20.348 21.5854 20.902 21.2437 21.2437C20.902 21.5854 20.348 21.5854 20.0063 21.2437L0.756282 1.99372C0.414573 1.65201 0.414573 1.09799 0.756282 0.756282Z"
              fill="#EF5C4A"
            />
          </g>
          <defs>
            <clipPath id="clip0">
              <rect
                width="21"
                height="21"
                fill="white"
                transform="translate(0.5 0.5)"
              />
            </clipPath>
          </defs>
        </svg>
      </button>
      <button
        class="mic"
        :class="{ active: muteMic }"
        @click="handleToggleAudio"
      >
        <svg
          v-if="!muteMic"
          width="22"
          height="22"
          viewBox="0 0 22 22"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0)">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M8.57549 1.71848C9.21848 1.0755 10.0905 0.714279 10.9999 0.714279C11.9092 0.714279 12.7812 1.0755 13.4242 1.71848C14.0672 2.36147 14.4284 3.23354 14.4284 4.14285V11C14.4284 11.9093 14.0672 12.7814 13.4242 13.4244C12.7812 14.0673 11.9092 14.4286 10.9999 14.4286C10.0905 14.4286 9.21848 14.0673 8.57549 13.4244C7.93251 12.7814 7.57129 11.9093 7.57129 11V4.14285C7.57129 3.23354 7.93251 2.36147 8.57549 1.71848ZM10.9999 2.42856C10.5452 2.42856 10.1092 2.60918 9.78768 2.93067C9.46619 3.25216 9.28557 3.68819 9.28557 4.14285V11C9.28557 11.4547 9.46619 11.8907 9.78768 12.2122C10.1092 12.5337 10.5452 12.7143 10.9999 12.7143C11.4545 12.7143 11.8906 12.5337 12.212 12.2122C12.5335 11.8907 12.7141 11.4547 12.7141 11V4.14285C12.7141 3.68819 12.5335 3.25216 12.212 2.93067C11.8906 2.60918 11.4545 2.42856 10.9999 2.42856Z"
              fill="white"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M5.00021 8.42856C5.4736 8.42856 5.85735 8.81231 5.85735 9.2857V11C5.85735 12.364 6.39919 13.6721 7.36366 14.6365C8.32813 15.601 9.63624 16.1428 11.0002 16.1428C12.3642 16.1428 13.6723 15.601 14.6368 14.6365C15.6012 13.6721 16.1431 12.364 16.1431 11V9.2857C16.1431 8.81231 16.5268 8.42856 17.0002 8.42856C17.4736 8.42856 17.8574 8.81231 17.8574 9.2857V11C17.8574 12.8186 17.1349 14.5628 15.8489 15.8487C14.563 17.1347 12.8188 17.8571 11.0002 17.8571C9.18158 17.8571 7.43744 17.1347 6.15148 15.8487C4.86551 14.5628 4.14307 12.8186 4.14307 11V9.2857C4.14307 8.81231 4.52682 8.42856 5.00021 8.42856Z"
              fill="white"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M11.0002 16.1429C11.4736 16.1429 11.8574 16.5266 11.8574 17V20.4286C11.8574 20.902 11.4736 21.2857 11.0002 21.2857C10.5268 21.2857 10.1431 20.902 10.1431 20.4286V17C10.1431 16.5266 10.5268 16.1429 11.0002 16.1429Z"
              fill="white"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M6.71436 20.4286C6.71436 19.9552 7.09811 19.5714 7.5715 19.5714H14.4286C14.902 19.5714 15.2858 19.9552 15.2858 20.4286C15.2858 20.902 14.902 21.2857 14.4286 21.2857H7.5715C7.09811 21.2857 6.71436 20.902 6.71436 20.4286Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0">
              <rect
                width="20.5714"
                height="20.5714"
                fill="white"
                transform="translate(0.714355 0.714279)"
              />
            </clipPath>
          </defs>
        </svg>
        <svg
          v-else
          width="22"
          height="22"
          viewBox="0 0 22 22"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0)">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M8.57549 1.71848C9.21848 1.0755 10.0905 0.714279 10.9999 0.714279C11.9092 0.714279 12.7812 1.0755 13.4242 1.71848C14.0672 2.36147 14.4284 3.23354 14.4284 4.14285V11C14.4284 11.9093 14.0672 12.7814 13.4242 13.4244C12.7812 14.0673 11.9092 14.4286 10.9999 14.4286C10.0905 14.4286 9.21848 14.0673 8.57549 13.4244C7.93251 12.7814 7.57129 11.9093 7.57129 11V4.14285C7.57129 3.23354 7.93251 2.36147 8.57549 1.71848ZM10.9999 2.42856C10.5452 2.42856 10.1092 2.60918 9.78768 2.93067C9.46619 3.25216 9.28557 3.68819 9.28557 4.14285V11C9.28557 11.4547 9.46619 11.8907 9.78768 12.2122C10.1092 12.5337 10.5452 12.7143 10.9999 12.7143C11.4545 12.7143 11.8906 12.5337 12.212 12.2122C12.5335 11.8907 12.7141 11.4547 12.7141 11V4.14285C12.7141 3.68819 12.5335 3.25216 12.212 2.93067C11.8906 2.60918 11.4545 2.42856 10.9999 2.42856Z"
              fill="white"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M5.00021 8.42856C5.4736 8.42856 5.85735 8.81231 5.85735 9.2857V11C5.85735 12.364 6.39919 13.6721 7.36366 14.6365C8.32813 15.601 9.63624 16.1428 11.0002 16.1428C12.3642 16.1428 13.6723 15.601 14.6368 14.6365C15.6012 13.6721 16.1431 12.364 16.1431 11V9.2857C16.1431 8.81231 16.5268 8.42856 17.0002 8.42856C17.4736 8.42856 17.8574 8.81231 17.8574 9.2857V11C17.8574 12.8186 17.1349 14.5628 15.8489 15.8487C14.563 17.1347 12.8188 17.8571 11.0002 17.8571C9.18158 17.8571 7.43744 17.1347 6.15148 15.8487C4.86551 14.5628 4.14307 12.8186 4.14307 11V9.2857C4.14307 8.81231 4.52682 8.42856 5.00021 8.42856Z"
              fill="white"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M11.0002 16.1429C11.4736 16.1429 11.8574 16.5266 11.8574 17V20.4286C11.8574 20.902 11.4736 21.2857 11.0002 21.2857C10.5268 21.2857 10.1431 20.902 10.1431 20.4286V17C10.1431 16.5266 10.5268 16.1429 11.0002 16.1429Z"
              fill="white"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M6.71436 20.4286C6.71436 19.9552 7.09811 19.5714 7.5715 19.5714H14.4286C14.902 19.5714 15.2858 19.9552 15.2858 20.4286C15.2858 20.902 14.902 21.2857 14.4286 21.2857H7.5715C7.09811 21.2857 6.71436 20.902 6.71436 20.4286Z"
              fill="white"
            />
          </g>
          <line
            x1="1.14728"
            y1="3.3406"
            x2="20.0262"
            y2="17.0368"
            stroke="white"
            stroke-width="2"
          />
          <defs>
            <clipPath id="clip0">
              <rect
                width="20.5714"
                height="20.5714"
                fill="white"
                transform="translate(0.714355 0.714279)"
              />
            </clipPath>
          </defs>
        </svg>
      </button>
      <button
        class="screen"
        :class="{ active: sharingScreen }"
        @click="handleShareScreen"
      >
        <svg
          width="22"
          height="22"
          viewBox="0 0 22 22"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M4 4C3.51675 4 3.125 4.39175 3.125 4.875V13.625C3.125 14.1082 3.51675 14.5 4 14.5H18C18.4832 14.5 18.875 14.1082 18.875 13.625V4.875C18.875 4.39175 18.4832 4 18 4H4ZM1.375 4.875C1.375 3.42525 2.55025 2.25 4 2.25H18C19.4497 2.25 20.625 3.42525 20.625 4.875V13.625C20.625 15.0747 19.4497 16.25 18 16.25H4C2.55025 16.25 1.375 15.0747 1.375 13.625V4.875Z"
            fill="var(--theme-color)"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M6.625 18.875C6.625 18.3918 7.01675 18 7.5 18H14.5C14.9832 18 15.375 18.3918 15.375 18.875C15.375 19.3582 14.9832 19.75 14.5 19.75H7.5C7.01675 19.75 6.625 19.3582 6.625 18.875Z"
            fill="var(--theme-color)"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M11 14.5C11.4832 14.5 11.875 14.8918 11.875 15.375V18.875C11.875 19.3582 11.4832 19.75 11 19.75C10.5168 19.75 10.125 19.3582 10.125 18.875V15.375C10.125 14.8918 10.5168 14.5 11 14.5Z"
            fill="var(--theme-color)"
          />
        </svg>
      </button>
      <button class="chat" :class="{ active: chat }" @click="handleToggleChat">
        <svg
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            class="stroke"
            d="M5.46757 23.75C5.54257 23.4762 5.37819 23.0956 5.22132 22.8213C5.17268 22.7393 5.11969 22.66 5.06257 22.5837C3.71711 20.5433 2.99998 18.1529 3.00007 15.7087C2.97757 8.69312 8.79507 3 15.9888 3C22.2626 3 27.5001 7.34625 28.7232 13.1156C28.9068 13.971 28.9996 14.8433 29.0001 15.7181C29.0001 22.7438 23.4069 28.5263 16.2132 28.5263C15.0688 28.5263 13.5257 28.2387 12.6838 28.0031C11.8419 27.7675 11.0013 27.455 10.7844 27.3713C10.5624 27.286 10.3266 27.2421 10.0888 27.2419C9.82947 27.241 9.57263 27.2926 9.33382 27.3937L5.09382 28.9237C5.00116 28.9638 4.90295 28.9895 4.80257 29C4.72316 28.9998 4.64459 28.9838 4.5714 28.953C4.49821 28.9222 4.43186 28.8772 4.37618 28.8206C4.3205 28.7639 4.27659 28.6968 4.24701 28.6232C4.21742 28.5495 4.20274 28.4706 4.20382 28.3913C4.20903 28.3216 4.2216 28.2527 4.24132 28.1856L5.46757 23.75Z"
            stroke="var(--theme-color)"
            stroke-width="1.5"
            stroke-miterlimit="10"
            stroke-linecap="round"
          />
          <path
            d="M10 18C11.1046 18 12 17.1046 12 16C12 14.8954 11.1046 14 10 14C8.89543 14 8 14.8954 8 16C8 17.1046 8.89543 18 10 18Z"
            fill="var(--theme-color)"
          />
          <path
            d="M16 18C17.1046 18 18 17.1046 18 16C18 14.8954 17.1046 14 16 14C14.8954 14 14 14.8954 14 16C14 17.1046 14.8954 18 16 18Z"
            fill="var(--theme-color)"
          />
          <path
            d="M22 18C23.1046 18 24 17.1046 24 16C24 14.8954 23.1046 14 22 14C20.8954 14 20 14.8954 20 16C20 17.1046 20.8954 18 22 18Z"
            fill="var(--theme-color)"
          />
        </svg>
      </button>
      <button
        class="option"
        :class="{ active: setting }"
        @click="handleShowSettings"
      >
        <svg
          width="21"
          height="21"
          viewBox="0 0 21 21"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M8.75 10.5C8.75 9.5335 9.5335 8.75 10.5 8.75C11.4665 8.75 12.25 9.5335 12.25 10.5C12.25 11.4665 11.4665 12.25 10.5 12.25C9.5335 12.25 8.75 11.4665 8.75 10.5Z"
            fill="var(--theme-color)"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M8.75 4.375C8.75 3.4085 9.5335 2.625 10.5 2.625C11.4665 2.625 12.25 3.4085 12.25 4.375C12.25 5.3415 11.4665 6.125 10.5 6.125C9.5335 6.125 8.75 5.3415 8.75 4.375Z"
            fill="var(--theme-color)"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M8.75 16.625C8.75 15.6585 9.5335 14.875 10.5 14.875C11.4665 14.875 12.25 15.6585 12.25 16.625C12.25 17.5915 11.4665 18.375 10.5 18.375C9.5335 18.375 8.75 17.5915 8.75 16.625Z"
            fill="var(--theme-color)"
          />
        </svg>
      </button>
    </div>
    <div class="end">
      <button class="end__session" @click="hanldeEndSessions">
        End Sessions
      </button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      hideBar: false,
      mic: true,
      cam: false,
      screen: false,
      chat: false,
      audioContext: null
    };
  },
  props: {
    name: {
      type: String,
      required: true
    },
    plan: {
      type: String,
      required: true
    },
    img: {
      type: String,
      default: "remove-me", //@TODO- Fix this issue
      required: false
    },
    setting: {
      type: Boolean,
      required: true
    },
    connectionState: {
      required: true
    },
    remoteStream: {
      required: true
    },
    muteMic: {
      type: Boolean,
      required: true
    },
    muteCamera: {
      type: Boolean,
      required: true
    },
    otherUserMicMuted: {
      required: false
    },
    sharingScreen: {
      type: Boolean,
      required: true
    }
  },
  watch: {
    connectionState(newValue) {
      if (newValue == "connected") {
        this.renderMeter();
        setTimeout(() => {
          this.hideBottomBar();
        }, 3000);
      }
    }
  },
  mounted() {
    // this.renderMeter();
  },
  methods: {
    showBottomBar() {
      if (this.connectionState == "connected") this.hideBar = false;
    },
    hideBottomBar() {
      if (this.connectionState == "connected") this.hideBar = true;
    },
    handleToggleAudio() {
      // if (this.muteMic && this.connectionState == "connected") {
      //   this.renderMeter();
      // } else if (!this.muteMic && this.connectionState == "connected") {
      //   if (this.audioContext) {
      //     this.audioContext.close();
      //   }
      // }
      this.$emit("toggle-audio");
    },
    handleToggleVideo() {
      this.$emit("toggle-video");
    },
    handleShareScreen() {
      this.$emit("share-screen");
    },
    handleShowSettings() {
      this.$emit("show-setting");
    },
    handleToggleChat() {
      this.$emit("toggle-chat");
    },
    hanldeEndSessions() {
      if (this.audioContext) {
        this.audioContext.close();
      }
      this.$emit("end-sessions");
    },
    renderMeter() {
      var max_level_L = 0;
      var old_level_L = 0;
      this.audioContext = new AudioContext();
      var microphone = this.audioContext.createMediaStreamSource(
        this.remoteStream
      );
      var javascriptNode = this.audioContext.createScriptProcessor(1024, 1, 1);

      microphone.connect(javascriptNode);
      javascriptNode.connect(this.audioContext.destination);
      javascriptNode.onaudioprocess = function(event) {
        var inpt_L = event.inputBuffer.getChannelData(0);
        var instant_L = 0.0;

        var sum_L = 0.0;
        for (var i = 0; i < inpt_L.length; ++i) {
          sum_L += inpt_L[i] * inpt_L[i];
        }
        instant_L = Math.sqrt(sum_L / inpt_L.length);
        max_level_L = Math.max(max_level_L, instant_L);
        instant_L = Math.max(instant_L, old_level_L - 0.008);
        old_level_L = instant_L;
        let percentage = (instant_L / max_level_L) * 100;
        if (percentage == 0) {
          if (document.getElementById("remoteAudio1")) {
            document.getElementById("remoteAudio1").style.fill = "none";
          }
          if (document.getElementById("remoteAudio2")) {
            document.getElementById("remoteAudio2").style.fill = "none";
          }
          if (document.getElementById("remoteAudio3")) {
            document.getElementById("remoteAudio3").style.fill = "none";
          }
        } else if (percentage > 0 && percentage < 30) {
          if (document.getElementById("remoteAudio1")) {
            document.getElementById("remoteAudio1").style.fill =
              "var(--theme-color)";
          }
          if (document.getElementById("remoteAudio2")) {
            document.getElementById("remoteAudio2").style.fill = "none";
          }
          if (document.getElementById("remoteAudio3")) {
            document.getElementById("remoteAudio3").style.fill = "none";
          }
        } else if (percentage > 30 && percentage < 60) {
          if (document.getElementById("remoteAudio1")) {
            document.getElementById("remoteAudio1").style.fill =
              "var(--theme-color)";
          }
          if (document.getElementById("remoteAudio2")) {
            document.getElementById("remoteAudio2").style.fill =
              "var(--theme-color)";
          }
          if (document.getElementById("remoteAudio3")) {
            document.getElementById("remoteAudio3").style.fill = "none";
          }
        } else if (percentage > 60) {
          if (document.getElementById("remoteAudio1")) {
            document.getElementById("remoteAudio1").style.fill =
              "var(--theme-color)";
          }
          if (document.getElementById("remoteAudio2")) {
            document.getElementById("remoteAudio2").style.fill =
              "var(--theme-color)";
          }
          if (document.getElementById("remoteAudio3")) {
            document.getElementById("remoteAudio3").style.fill =
              "var(--theme-color)";
          }
        }
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.hide-bar {
  opacity: 0;
}
.bottombar {
  height: 80px;
  padding: 0px 24px;
  z-index: 4;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: #fff;
  .btn-fill {
    font-family: "Nunito", sans-serif;
    width: 62px;
    height: 24px;
    font-weight: 600;
    font-size: 12px;
    line-height: 16px;
    padding: 0;
    border-radius: 20px;
  }
  .userimg {
    img {
      height: 40px;
      width: 40px;
      border-radius: 50%;
    }
  }
  .title,
  .with {
    font-family: "Nunito", sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 22px;
    color: #000000;
    margin: 0;
  }
  .with {
    font-size: 14px;
    line-height: 19px;
    color: #8d99a0;
    svg {
      margin-left: 10px;
    }
  }

  .actions {
    button {
      margin: 0 5px;
      width: 56px;
      height: 56px;
      border-radius: 50%;
      border: 1px solid var(--theme-color);
      background: #fff;
      &:not(.chat) {
        path {
          fill: var(--theme-color) !important;
        }
      }

      &.chat {
        .stroke {
          fill: unset;
          stroke: var(--theme-color) !important;
        }
      }
      &:hover,
      &.active {
        background: var(--theme-color);
        path {
          fill: #fff !important;
        }
      }
      &.active {
        &:hover {
          box-shadow: 0px 0px 4px 0px #333;
        }
      }
      &.mic {
        border: 1px solid var(--theme-color);
        &:hover,
        &.active {
          background: #ef5c4a;
          path {
            fill: #fff !important;
          }
        }
      }
      &.video {
        border: 1px solid var(--theme-color);
        &:hover,
        &.active {
          background: #ef5c4a;
          path {
            fill: #fff !important;
          }
        }
      }
    }
  }
  .end__session {
    width: 157px;
    height: 38px;
    background: rgba(239, 92, 74, 0.08);
    border-radius: 8px;
    border: 1px solid rgba(239, 92, 74, 0.08);
    font-family: "Nunito", sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 22px;
    /* identical to box height */

    display: flex;
    align-items: center;
    justify-content: center;
    text-transform: uppercase;
    letter-spacing: 0.05em;

    /* Danger */

    color: #ef5c4a;
    &:hover {
      background: rgba(239, 93, 74, 0.2);
    }
  }
}

@media (max-width: 768px) {
  .bottombar {
    .actions {
      button {
        height: 40px;
        width: 40px;
      }
    }
    .title,
    .with {
      display: none;
    }
  }
}
@media (max-width: 550px) {
  .bottombar {
    background-color: #474d52;
    height: 120px;
    padding-bottom: 20px;
    flex-direction: column;
    .profile {
      display: none !important;
    }
  }
}
</style>
